import { render, staticRenderFns } from "./ModalLicenceApplication.vue?vue&type=template&id=22156592&scoped=true&"
import script from "./ModalLicenceApplication.vue?vue&type=script&lang=ts&"
export * from "./ModalLicenceApplication.vue?vue&type=script&lang=ts&"
import style0 from "./ModalLicenceApplication.vue?vue&type=style&index=0&id=22156592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22156592",
  null
  
)

export default component.exports